var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-btn"},[_c('el-button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }